import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

export default class TwoColumnText extends Component {
  render() {
    const {
      title,
      firstColumn,
      secondColumn
    } = this.props

    return (
      <Wrapper>
        <Container fluid>
          {title && (
            <Row>
              <Col
                sm={10}
                smOffset={1}
              >
                <Title>{title}</Title>
              </Col>
            </Row>
          )}
          <Row>
            <Col
              sm={5}
              smOffset={1}
            >
              <Text dangerouslySetInnerHTML={{ __html: firstColumn }} />
            </Col>
            <Col
              sm={5}
            >
              <Text dangerouslySetInnerHTML={{ __html: secondColumn }} />
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  margin-bottom: 0px;
`

const Title = styled.h2`
  font-size: 40px;
  line-height: normal;

  ${media.xs`
    font-size: 30px;
  `}
`

const Text = styled.div`
  font-weight: 300;
  color: ${props => props.theme.colors.text};
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/TwoColumnText/index.js